import { Injectable } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { NguCarouselConfig } from '@ngu/carousel';
import {Observable} from 'rxjs';
import {IIdentify} from '../../../models/identify.interface';
import {select, Store} from '@ngrx/store';
import {selectIdentify} from '../../../store/selectors/identify.selectors';
import {IAppState} from '../../../store/state/app.state';
import {environment} from '../../../../environments/environment';
import {DeviceDetectorService} from 'ngx-device-detector';

/**
 * Service to check which type of media match
 */
@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {

  /**
   * Extra small media size
   */
  extraExtraSmallSize: MediaQueryList;

  /**
   * Extra small media size
   */
  extraSmallSize: MediaQueryList;

  /**
   * Small media size
   */
  smallSize: MediaQueryList;

  /**
   * Medium media size
   */
  mediumSize: MediaQueryList;

  /**
   * Large media size
   */
  largeSize: MediaQueryList;

  /**
   * Extra Large media size
   */
  extraLargeSize: MediaQueryList;

    /**
   * Extra Large media size
   */
  veryExtraLargeSize: MediaQueryList;

  fullSize: MediaQueryList;

  carouselConfig: NguCarouselConfig;

  public identify$: Observable<IIdentify>;

  /**
   * Service contructor set type based on media match
   * @param media A utility for calling matchMedia queries
   */
  constructor( media: MediaMatcher, private _store: Store<IAppState>, private deviceService: DeviceDetectorService) {

    this.identify$ = this._store.pipe(select(selectIdentify));

    this.extraExtraSmallSize = media.matchMedia('(max-width: 320.0px)');

    this.extraSmallSize = media.matchMedia('(max-width: 575.98px)');

    this.smallSize = media.matchMedia('(min-width: 576px) and (max-width: 767.98px)');

    this.mediumSize = media.matchMedia('(min-width: 768px) and (max-width: 991.98px)');

    this.largeSize = media.matchMedia('(min-width: 992px) and (max-width: 1199.98px)');

    this.extraLargeSize = media.matchMedia('(min-width: 1200px) and (max-width: 1599.98px)');

    this.fullSize = media.matchMedia('(min-width: 1200px)');

    this.veryExtraLargeSize = media.matchMedia('(min-width: 1600px)');

    this.identify$.subscribe((indent) => {
      if (indent && indent.token && environment.betflafCID.includes(indent.token) && this.deviceService.isDesktop()) {

        this.extraExtraSmallSize = media.matchMedia('(max-width: 320.0px)');

        this.extraSmallSize = media.matchMedia('(max-width: 575.98px)');

        this.smallSize = media.matchMedia('(min-width: 576px) and (max-width: 767.98px)');

        this.mediumSize = media.matchMedia('(min-width: 768px) and (max-width: 991.98px)');

        this.largeSize = media.matchMedia('(min-width: 992px) and (max-width: 1023.98px)');

        this.extraLargeSize = media.matchMedia('(min-width: 1024px) and (max-width: 1599.98px)');

        this.fullSize = media.matchMedia('(min-width: 1024px)');

        this.veryExtraLargeSize = media.matchMedia('(min-width: 1600px)');
      }
    });

    this.carouselConfig = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      interval: {timing: 4000, initialDelay: 1000},
      loop: true,
      touch: true,
      velocity: 0.2,
      point: {
        visible: false,
        hideOnSingleSlide: true
      }
    };

  }
}
